// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import videojs from "video.js";
import lazy from "./directives/lazy"
import banner from "./components/global/banner.vue"
// import "video.js/dist/video-js.css";

// import axios from 'axios'
// import VueAxios from 'vue-axios'
import store from './store/index.js'
// import 'video.js/dist/video-js.css'

// import common from './api/common'
// Vue.use(common)
// Vue.use(Swiper)
//引入自定义插件https用于接口请求
import MyHttpServer from './plugins/https'
Vue.use(MyHttpServer)
Vue.use(ElementUI);
Vue.directive("lazy",lazy)
Vue.component("banner",banner)
// 引用全局msg
import msg from './components/message/message.js'
Vue.prototype.$msg = msg;
// 注册全局组件
import './components/global/global.js'
// Vue.use(VueAxios, axios)

Vue.prototype.$video = videojs;
// 添加仓库
Vue.prototype.$store = store
// Vue.prototype.$url = window.gurl.SERVICE_CONTEXT_PATH
Vue.config.productionTip = false

// 解决vuex 刷新数据丢失问题
import './store/refresh.js'

// 路由拦截
router.afterEach((to, from) => {
  window.scrollTo(0, 0)
})
router.beforeEach((to, from, next) => {
  // console.log('在路由发生变化的时候修改页面')
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js